import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salse-quotation-form',
  templateUrl: './salse-quotation-form.component.html',
  styleUrls: ['./salse-quotation-form.component.css']
})
export class SalseQuotationFormComponent implements OnInit {
  title="Create Quotation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component.ts